import { Component, OnDestroy, OnInit } from '@angular/core';
import { SampleSearchObject, SubmissionSearchUserInfoObject } from '../search-object';
import { Subscription } from "rxjs";

import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { FormControl } from '@angular/forms';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateUtil } from '../date-util'
import {PaginationObject} from '../pagination-object';

import * as _moment from 'moment';

declare var $: any;

const moment = _moment;

@Component({
    selector: 'sample-search-sidebar',
    templateUrl: './sample-search-sidebar.component.html',
    styleUrls: [ './sample-search-sidebar.component.scss' ],
    providers: [
      {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
      {provide: MAT_DATE_FORMATS, useValue: DateUtil.MY_FORMATS}
      ]
})
export class SampleSearchSidebarComponent implements OnInit, OnDestroy {
    date = new FormControl(moment());
    minDate = new Date(2000, 0, 1);
    maxDate = new Date();
    selectedLocus = '';
    searchCriteria = new SampleSearchObject();
    userSearchInfo = new SubmissionSearchUserInfoObject();
    pagination: PaginationObject = new PaginationObject();

    private userInfoSubscription: Subscription;
    private searchCriteriaSubscription: Subscription;
    private paginationSubscription: Subscription;

    constructor(private submissionHistoryService: SubmissionHistoryService) {
    }


    ngOnInit() {
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => this.userSearchInfo = message);
        this.paginationSubscription = this.submissionHistoryService.currentSamplePagination.subscribe(message => this.pagination = message);
        this.searchCriteriaSubscription = this.submissionHistoryService.currentSampleSearchCriteria.subscribe(
            message => this.searchCriteria = message
            );
        this.selectedLocus = '';
    }


    ngOnDestroy() {
        this.userInfoSubscription.unsubscribe();
        this.searchCriteriaSubscription.unsubscribe();
        this.paginationSubscription.unsubscribe();
    }


    onSubmit() {
        const startDate = document.querySelector('#startDate') as HTMLInputElement;
        const endDate = document.querySelector('#endDate') as HTMLInputElement;

        if (DateUtil.validateDateTime((document.querySelector('#startDate') as HTMLInputElement).value) && DateUtil.validateDateTime((document.querySelector('#startTime') as HTMLInputElement).value))  {
          this.submissionHistoryService.clearSampleSearchTable();
          this.submissionHistoryService.clearSamplePagination(0);
          this.updateTableDataSearch(this.searchCriteria);
          this.getTotalCountSearch(this.searchCriteria);
        } else {
            return;
        }
    }

    public updateTableDataSearch(search: SampleSearchObject): void {
        const startDateTime = (document.querySelector('#startDate') as HTMLInputElement).value + ' ' + (document.querySelector('#startTime') as HTMLInputElement).value;
        const endDateTime = (document.querySelector('#endDate') as HTMLInputElement).value + ' ' + (document.querySelector('#endTime') as HTMLInputElement).value;
        this.submissionHistoryService.getSampleSearchTableContent(search, startDateTime.trim(), endDateTime.trim(), 0);
    }

    public getTotalCountSearch(search: SampleSearchObject): void {
        const startDateTime = (document.querySelector('#startDate') as HTMLInputElement).value + ' ' + (document.querySelector('#startTime') as HTMLInputElement).value;
        const endDateTime = (document.querySelector('#endDate') as HTMLInputElement).value + ' ' + (document.querySelector('#endTime') as HTMLInputElement).value;
        this.submissionHistoryService.getSampleSearchTableContentCount(search, startDateTime.trim(), endDateTime.trim());
    }

    clear() {
        this.submissionHistoryService.clearSampleSearchTable();
        this.submissionHistoryService.clearSampleSearchCriteria();
        this.submissionHistoryService.clearSamplePagination(0);

        (document.querySelector('#startDate') as HTMLInputElement).value = '';
        (document.querySelector('#endDate') as HTMLInputElement).value = '';
        (document.querySelector('#startTime') as HTMLInputElement).value = '';
        (document.querySelector('#endTime') as HTMLInputElement).value = '';
    }

    public onStartDateChange(searchValue: string) {
        console.log(searchValue);
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            document.querySelector( '#startDateFormField' ).classList.remove( 'mat-form-field-invalid' )
        } else {
            document.querySelector( '#startDateFormField' ).classList.add( 'mat-form-field-invalid' )
        }
    }


    public onEndDateChange(searchValue: string) {
        console.log(searchValue);
        if (DateUtil.validateDateTime(searchValue) || (searchValue.length === 0)) {
            document.querySelector( '#endDateFormField' ).classList.remove( 'mat-form-field-invalid' )
        } else {
            document.querySelector( '#endDateFormField' ).classList.add( 'mat-form-field-invalid' )
        }
    }

    public onStartDateSelected() {
        document.querySelector( '#startDateFormField' ).classList.remove( 'mat-form-field-invalid' )
    }

    public onEndDateSelected() {
        document.querySelector( '#endDateFormField' ).classList.remove( 'mat-form-field-invalid' )
    }

}
